import { render, staticRenderFns } from "./ChooseShop.vue?vue&type=template&id=0dc68019&scoped=true"
import script from "./ChooseShop.vue?vue&type=script&lang=js"
export * from "./ChooseShop.vue?vue&type=script&lang=js"
import style0 from "./ChooseShop.vue?vue&type=style&index=0&id=0dc68019&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc68019",
  null
  
)

export default component.exports